import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ContentData } from 'components/cases/common/Interview/fragments/type'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
gsap.registerPlugin(ScrollTrigger)

const contentData: ContentData[][] = [
  [
    {
      type: 'sectionTitle',
      text: '5年ぶりのリニューアル。デザイン力×サイト分析の納得度が決め手',
    },
    {
      type: 'textBox',
      texts: [
        '―― 本プロジェクトのパートナー企業として、アイスリーデザインにご依頼いただいた理由を教えていただけますか？',
      ],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '長澤さん',
      texts: [
        'まず、アイスリーデザインさんがこれまで手がけてきたサイトのデザインが良いと思いました。今回はデザインだけでなく、分析段階からご協力いただけることが条件だったので、分析力への期待は大きなポイントとなりました。発注前に各社に簡易的なサイト分析をお願いしていたのですが、アイスリーデザインさんの分析はその指摘内容にとても納得感がありました。',
        'そして何よりも決め手となったのは、コミュニケーションですね。ひとつひとつの連絡にとてもスムーズな対応をしていただけたので、安心感がありました。',
      ],
    },
    {
      type: 'textBox',
      texts: ['―― 具体的には、パートナー企業にどのような役割を期待されていましたか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '長澤さん',
      texts: [
        '5年ぶりのリニューアルですので、デザインのトレンドに合致しているものにしていきたいという思いはもちろん、CVRの改善も大きな目的でした。また、長年運営しているサイトですので、既存ユーザーに使い方を再学習してもらう必要のないリニューアルを実現したいと考えていました',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '3ステップで行った、アイスリーデザインのサイト分析',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/seyfert/interview1.webp',
      alt: 'インタビュー写真',
      text: 'アイスリーデザインのプロジェクトメンバー。左からリサーチャー武本、プロジェクトデザイナー今野、リサーチャー木下',
    },
    {
      type: 'textBox',
      texts: [
        '本プロジェクトの課題は「CVRの改善」と広範に及ぶものだったため、アイスリーデザインは広い観点でのサイト分析を行うべく、「定量分析」「ヒューリスティック分析」「ユーザビリティテスト」という3つの手法を採用しました。',
      ],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '手法1.定量分析',
      texts: [
        '弊社リサーチャーが最初に考えたことは、「re-quest/QJ navi」におけるCVの定義。本サイトのゴール達成における重要CVは「求人への応募」以上に、転職を考えるたびにサイトを訪れてくれる「会員」と「UU」の獲得と考え、Googleアナリティクスの数値を確認していきました。そこには再訪問率といった直接的な数値の確認はもちろん、会員登録に至る上で何がハードルになっているのか、あるいは会員登録に至ったユーザーがどのような行動をしているのか等の分析が含まれています。',
      ],
      color: 'white',
    },
    {
      type: 'greyBox',
      name: '手法2.ヒューリスティック分析',
      texts: [
        '弊社デザイナーが「re-quest/QJ navi」を実際に見ながら、サイト自体がどのような課題を抱えているのかを抽出していくのが、ヒューリスティック分析です。今回は定量分析ではわからない具体的な課題を見つけることが主な目的となりました。',
      ],
      color: 'white',
    },
    {
      type: 'greyBox',
      name: '手法3.ユーザビリティテスト',
      texts: [
        '最後に行ったのが「ユーザビリティテスト」です。ここでは「re-quest/QJ navi」のユーザーとなる美容師の方々をお呼びし、実際にサイトを触っていただきながら課題を抽出いたしました。言語化しづらいユーザーの感情や、無意識的な行動を、弊社スタッフが分析＆グルーピングすることで、デザイナー視点とはまた異なるリアルなユーザー目線での課題を洗い出すことができました。',
      ],
      color: 'white',
    },
    {
      type: 'textBox',
      texts: [
        '以上3つの分析を踏まえ、弊社は「re-quest/QJ navi」最大のCVは会員獲得だと結論づけました。その上で会員登録しやすい導線設計を行ったほか、ヒューリスティック分析で課題として抽出された「見やすさ」の改善の優先度を上げ、新たなデザインを制作いたしました。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '長澤さん',
      texts: [
        'アイスリーデザインさんにご依頼して、”本当に良かったな”と思っています。アイスリーデザインさんが出してくれたレポートは、私たち自身も「改修した方がいいんだろうな」と思っていた部分も多々あったのですが、その改修の必要性がわかったこと自体が大きな収穫でした。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '新デザインで、CVRが20％改善',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/seyfert/interview2.webp',
      alt: 'インタビュー写真',
      text: '株式会社セイファート サロンコミュニケーション事業部 営業企画セクション マネージャー長澤涼子さん',
    },
    {
      type: 'textBox',
      texts: ['―― プロジェクト進行の中で印象に残ったことはありますか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '長澤さん',
      texts: [
        'デザインのトンマナや雰囲気を方向づけるムードボード（注：イラストや写真をコラージュしたデザインラフの一種）を最初に見せていただき、弊社の他スタッフにも展開したのですが、みんなでイメージを掴むことができましたし、期待感が高まりました。そこで一気に進む方向が見えたのが印象的でした。',
        'そしてプロジェクト全体として、とてもスムーズに進行していただけたと感じています。',
        'サイト自体の仕上がりもとても今のトレンドに合致しているデザインになったと思いますし、文字のサイズや色の使い方、コンテンツの配置も含め、とにかく見やすくなった、読みやすくなったという印象ですね。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: 'これまでもこれからも、美容に携わる人たちのために事業を展開したい',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/seyfert/interview3.webp',
      alt: 'インタビュー写真',
      text: '株式会社セイファート 常務取締役 第1営業本部 本部長鹿島修司さん',
    },
    {
      type: 'textBox',
      texts: ['―― 今後「re-quest/QJ navi」がどのようなサイトを目指されるのかを教えてください。'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '鹿島さん',
      texts: [
        '美容業界の求人サイトは、主に有資格者を対象としているため対象者の絶対数が少なく熾烈な競争が繰り広げられている状況です。そのような状況においても「re-quest/QJ navi」は日本全国の美容師さんから信用される、使い勝手の良い、日本一の求人サイトにしていきたいなと思っています。今回はデザインのリニューアルだったため、根本的に大きな変化があったわけではないので、これを足掛かりに大きく機能改修をしていきたいです。',
      ],
    },
    {
      type: 'textBox',
      texts: ['―― 株式会社セイファートとしての展望はいかがですか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '鹿島さん',
      texts: [
        '我々は「美容に携わるひとたちとともに、世の中に新しい価値を創造する」というテーマを持っています。そして、そこで働いている美容師さんやオーナーさんたちがいかに輝いて仕事をできるか、幸せになれるかにコミットしています。その軸をぶらさず、これからも彼らに向けたサービスを展開していきたいと思っています。',
      ],
    },
  ],
]

const sectionTitle: { title: string; sub_title: string } = {
  title: 'Interview',
  sub_title: 'インタビュー',
}
const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>()
  const image = useRef<HTMLImageElement>()
  const text_container = useRef<HTMLDivElement>()
  // const container = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from(image.current, tweenVars, 0.2)
    timeline.from(text_container.current, tweenVars, 0.4)

    ScrollTrigger.create({
      animation: timeline,
      trigger: wrapper.current,
      start: 'top-=100 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
